<div class="signing-forms-wrapper">
    <div class="signing-modal-header">
        <span class="title">{{title ?? activeTab}}</span>
        <button #initialFocus class="button-undecorated" [attr.aria-label]="'Close Signing Modal'"
            (click)="modalService.closeModal(modalName.SignIn)">
            <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
        </button>
    </div>
    @if (getMessage()) {
    <p class="description_message">
        {{getMessage()}}
    </p>
    }
    <cwo-signing-forms [submitButton]="submitButton" [activePageInput]="activeTab" class="signing-forms"
        [hideGuestButton]="true" (activePageChange)="activePageChange($event)" />
</div>